



































































import Vue from "vue";
import Component from "vue-class-component";
import { cloneDeep } from 'lodash';

function toSortScore(key) {
  if (key === 'name') return -99999
  return parseInt(key.replace(/\D/g, ""))
}

function compareColumn(a, b) {
  return toSortScore(a.key) - toSortScore(b.key)
}

@Component({})
export default class MyComponent extends Vue {
  playerText = '';
  voteText = '';
  firstData = true;
  dates: any[] = []
  actions: any[] = [
    {text: '死', variant: 'danger'},
  ]

  options: any[] = [
      {text: '狼', variant: 'danger', color: '#fff', bg: '#FF0000'},
      {text: '狂', variant: 'danger', color: '#fff', bg: '#FF0000'},
      {text: '白', variant: 'light', color: '#000', bg: '#fff'},
      {text: '占', variant: 'primary', color: '#fff', bg: '#9933FF'},
      {text: '靈', variant: 'primary', color: '#fff', bg: '#009900'},
      {text: '獵', variant: 'primary', color: '#fff', bg: '#3399FF'},
      {text: '共', variant: 'info', color: '#fff', bg: '#CC9966'},
      {text: '戀', variant: 'info', color: '#fff', bg: '#FF80FF'},
      {text: '狐', variant: 'warning', color: '#fff', bg: '#CC0099'},
  ]

  
  playerNotes: any[] = [];

  items: any = []
  fields: any = []

  copy(pn): void {
    this.playerNotes.push(cloneDeep(pn))
  }

  remove(index): void {
    this.playerNotes = this.playerNotes.filter((pn, idx) => index !== idx)
  }

  doAction(p, action): void {
    if (action.text === '死')
    p.dead = !p.dead;
  }

  addTag(p, option): void {
    if (!p.tags.some(t => t.text === option.text)) {
      p.tags = [...p.tags, option]
    }
  }

  removeTag(p, tag) {
    p.tags = p.tags.filter(t => t.text !== tag.text)
  }

  clear(): void {
    this.items = []
    this.fields = []
    this.dates = []
    this.firstData = true;
  }

  setPlayers(): void {
    const players: any[] = []
    const lines = this.playerText.split('\n')
    console.log(lines)
    lines.forEach((line: string) => {
      const names = line.split('\t◆')
      names.forEach((name, index) => {
        if (index === 0) return;
        players.push({
          name,
          dead: false,
          tags: this.options.map(o => {
            const rs = Object.assign({}, o); 
            rs.active = false
            return rs;
          })
        })
      })
    })
    this.playerNotes.push(players)
  }

  calculate(): void {
    const lines = this.voteText.split("\n");
    let voteKey: any;
    let toKey: any;
    let gotVotesKey: any;
    lines.forEach((line, index) => {
      let dayText;
      if (index === 0) {
        dayText = line;
        if (!this.dates.some(d => d.dayText === dayText)) {
          this.dates.push({
            key: dayText,
            dayText: dayText
            // variant: this.dates.length % 2 === 0 ? 'primary': 'secondary'
          });
          this.dates = (this.dates as any[]).sort(compareColumn)
        } 
        voteKey = `${dayText}_vote`;
        toKey = `${dayText}_to`;
        gotVotesKey = `${dayText}_got`;
        if (this.firstData) {
          this.fields.push({ key: 'name', label: 'name' })
        }
        this.fields.push({ key: gotVotesKey, label: '得', sortable: true })
        this.fields.push({ key: voteKey, label: '票', sortable: true })
        this.fields.push({ key: toKey, label: '投', sortable: true })
        this.fields = (this.fields as any[]).sort(compareColumn)
      } else {
        const cols = line.split("\t");
        if (cols.length < 3) return;
        const from = cols[0];
        const gotVotes = cols[1].replace(/\D/g, "");
        const giveVotes = cols[2].replace(/\D/g, "");
        const to = cols[3];

        if (!this.items.some((i: any) => i.name === from)) {
          this.items.push({
            name: from
          })
        }

        const row = this.items.find((i: any) => i.name === from)
        row[voteKey] = giveVotes;
        row[gotVotesKey] = gotVotes;
        row[toKey] = to;
      }
    });

  }
}
